import Module from 'models/Module';
import StudentGradebookEntry from 'models/StudentGradebookEntry';
import React from 'react';
import ModuleView from 'view/components/student/classroom/ModuleView';

interface ModulePreviewProps {
  module: Module;
  onSelect?: (module: Module) => void;
  onSelectAssignment?: (assignment: StudentGradebookEntry) => void;
  onExit: () => void;
}

const ModulePreview: React.FC<ModulePreviewProps> = ({
  module,
  onSelect,
  onSelectAssignment,
  onExit,
}) => {
  if (!module) return null;
  return (
    <ModuleView
      moduleId={module?.id}
      onExit={onExit}
      onSelect={onSelect}
      onSelectAssignment={onSelectAssignment}
    />
  );
};

export default ModulePreview;
